import React, { ReactNode, Suspense } from 'react';

const LazyPage = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<>Loading</>}>{children}</Suspense>
);

export default LazyPage;
